// index.ts
import arJson from './json/ar'
import benJson from './json/ben'
import burJson from './json/bur'
import enJson from './json/en'
import esJson from './json/es'
import guiguiEnJson from './json/guiguiEn.json'
import idJson from './json/id'
import kmJson from './json/km'
import korJson from './json/ko'
import kzJson from './json/kz'
import ruJson from './json/ru'
import thJson from './json/th'
import trJson from './json/tr'
import uhJson from './json/ug'
import viJson from './json/vi'
import zhJson from './json/zh'
import zhTcJson from './json/zh_tc'

export const messages = {
  zh: zhJson,
  en: enJson,
  es: esJson,
  ar: arJson,
  vi: viJson,
  kz: kzJson,
  th: thJson,
  id: idJson,
  ug: uhJson,
  guiguiEn: guiguiEnJson,
  zh_hant: zhTcJson,
  ru: ruJson,
  kor: korJson,
  bur: burJson,
  ben: benJson,
  tr: trJson,
  km: kmJson,
}
